import Link from 'src/components/primitives/Link/Link';
import { DefinitionTooltipConfig } from 'src/components/Tooltip/DefinitionTooltip/types';
import { QUOTE_ASSET_SYMBOL, VELOCITY_DOCS_URL } from 'src/constants/constants';

/**
 * Tooltips used across the app that aren't specific to a page, dialog, or table.
 */
export const commonTooltips = {
	unsettledBalance: {
		title: 'Unsettled Balance',
		body: (
			<>
				This includes funding fees, position P&L, and referral fees. Claiming
				unsettled balances will update your available {QUOTE_ASSET_SYMBOL}{' '}
				balance for staking and withdrawals.
				<Link
					href={`${VELOCITY_DOCS_URL}/profit-loss/what-is-unsettled-profit-loss`}
					openInNewTab
				>
					Learn more
				</Link>
			</>
		),
	},
	selfImposedMaxLeverage: {
		title: 'Self-Imposed Max Leverage',
		body: 'Your max amount shown here is lower than the protocol allows due to self imposed max account leverage. You can adjust this in settings.',
	},
	stakingSubaccountWithdrawalLimits: {
		title: 'Withdrawal Limits',
		body: (
			<>
				<p>Staking from a Velocity account is subject to withdrawal limits.</p>
				<p>Velocity limits daily withdrawals to protect the protocol. </p>
				<Link
					href={`${VELOCITY_DOCS_URL}/risk-and-safety/risk-parameters`}
					openInNewTab
				>
					Learn more
				</Link>
			</>
		),
	},
} satisfies Record<string, DefinitionTooltipConfig>;
